import React from "react";

import { type TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

export const TotalBudgetHeaderContent = ({
  column,
  children,
}: TableHeaderRow.ContentProps) => {
  const { formattedCycleDateRange } = useClientSettings();

  return (
    <>
      <div className="text-xs w-full flex items-center px-2">
        <span className="overflow-hidden min-w-[10px] flex-1">
          {children}
          {` (${formattedCycleDateRange})`}
        </span>
      </div>
      <div className="header-column-separator"></div>
    </>
  );
};
